var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-card", { staticClass: "box-card mb10" }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("div", { staticStyle: { width: "460px" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "24px",
                    "font-weight": "bold",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.AnJunManagementBoard"))
                    ),
                  ]),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v(_vm._s(_vm.$t("GlobalSetObj.DeliveryOutlets"))),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "colorAdaeb3",
                  staticStyle: { "font-size": "15px" },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("customerManagements.dataUpdateTime"))
                    ),
                  ]),
                  _vm._v("： " + _vm._s(_vm.updateTime) + " "),
                ]
              ),
            ]),
            _c("div", { staticStyle: { flex: "1" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c("div", { staticStyle: { width: "350px" } }, [
                    _c("div", { staticClass: "dateMonthRadio" }, [
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3 borderR",
                          class:
                            _vm.queryForm.period === "yesterday"
                              ? "activeDateMonth"
                              : "",
                          on: {
                            click: function ($event) {
                              return _vm.handlePeriodChange("yesterday")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.yesterday")))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3 borderR",
                          class:
                            _vm.queryForm.period === "today"
                              ? "activeDateMonth"
                              : "",
                          on: {
                            click: function ($event) {
                              return _vm.handlePeriodChange("today")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("newOrder.today")))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3 borderR",
                          class:
                            _vm.queryForm.period === "month"
                              ? "activeDateMonth"
                              : "",
                          on: {
                            click: function ($event) {
                              return _vm.handlePeriodChange("month")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("newOrder.thisMonth")))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3",
                          class:
                            _vm.queryForm.period === "lastMonth"
                              ? "activeDateMonth"
                              : "",
                          on: {
                            click: function ($event) {
                              return _vm.handlePeriodChange("lastMonth")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.lastMonth")))]
                      ),
                    ]),
                    _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          staticClass: "dateRangeStyle",
                          attrs: {
                            size: "small",
                            type: "daterange",
                            "range-separator": "-",
                            "start-placeholder": _vm.$t(
                              "GlobalSetObj.startDate"
                            ),
                            "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                          },
                          model: {
                            value: _vm.queryForm.dateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "dateRange", $$v)
                            },
                            expression: "queryForm.dateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "regionCon" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          padding: "0 10px",
                          width: "100%",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { flex: "1", padding: "0 5px" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "colorAdaeb3",
                                staticStyle: {
                                  "font-size": "13px",
                                  "margin-bottom": "10px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("collectionCenter.region"))
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      size: "small",
                                      multiple: "",
                                      filterable: "",
                                      "collapse-tags": "",
                                    },
                                    on: { change: _vm.selectRegionChange },
                                    model: {
                                      value: _vm.queryForm.areaIdList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm,
                                          "areaIdList",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.areaIdList",
                                    },
                                  },
                                  _vm._l(_vm.regionOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          _vm.$i18n.locale === "zh"
                                            ? item.zhName
                                            : item.puName,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "120px",
                              "padding-left": "10px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "colorAdaeb3",
                                staticStyle: {
                                  "font-size": "13px",
                                  "margin-bottom": "10px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("collectionCenter.state")))]
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      size: "small",
                                      multiple: "",
                                      filterable: "",
                                      "collapse-tags": "",
                                    },
                                    on: { change: _vm.selectStateChange },
                                    model: {
                                      value: _vm.queryForm.stateList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm,
                                          "stateList",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.stateList",
                                    },
                                  },
                                  _vm._l(_vm.receiveStateList, function (item) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: item },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "selectIcon",
                            staticStyle: { flex: "1", "padding-left": "10px" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "colorAdaeb3",
                                staticStyle: {
                                  "font-size": "13px",
                                  "margin-bottom": "10px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("collectionCenter.dot")))]
                            ),
                            _c(
                              "div",
                              [
                                _c("ElSelectV2", {
                                  attrs: {
                                    multiple: "",
                                    clearable: "",
                                    options: _vm.siteList,
                                    filterable: "",
                                    "collapse-tags": "",
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.departmentList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm,
                                        "departmentList",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.departmentList",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "54px",
                              "text-align": "right",
                            },
                          },
                          [
                            _c("el-button", {
                              staticStyle: {
                                "font-size": "20px",
                                padding: "5px 10px",
                              },
                              attrs: {
                                type: "primary",
                                size: "mini",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.getAllData },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { "padding-right": "5px" }, attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "box-card mb10" }, [
                _c(
                  "div",
                  {
                    staticClass: "mb10 titleCon",
                    staticStyle: { "line-height": "24px" },
                  },
                  [
                    _vm._v("入库数据监控 Monitoramento de dados de entrada "),
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "bottom-start", trigger: "hover" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              padding: "0",
                              "line-height": "16px",
                            },
                            attrs: {
                              slot: "reference",
                              type: "text",
                              size: "mini",
                            },
                            slot: "reference",
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-more",
                              staticStyle: {
                                "margin-left": "10px",
                                "font-size": "24px",
                                color: "#00A551",
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t("collectionCenter.detail"),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewDataTable(1)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-tiaozhuan",
                                      staticStyle: { "font-size": "20px" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t("GlobalSetObj.Download"),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadData(1)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-xiazai",
                                      staticStyle: { "font-size": "20px" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c("div", { staticStyle: { flex: "1", padding: "0 5px" } }, [
                    _c("div", { staticClass: "warehousingCon" }, [
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3",
                          staticStyle: {
                            "font-size": "14px",
                            "margin-bottom": "5px",
                          },
                        },
                        [_vm._v("应入库票数")]
                      ),
                      _c("div", { staticClass: "itemPu colorAdaeb3" }, [
                        _vm._v("Qtd. de Volumes para Entrada"),
                      ]),
                      _c("div", { staticClass: "itemQuantity" }, [
                        _vm._v(_vm._s(_vm.inboundData.exceptWaybillCnt)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "itemIconCon",
                          staticStyle: { background: "#fffbea" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "itemIcon",
                              staticStyle: { background: "#fdf2c3" },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-ruku",
                                staticStyle: {
                                  "font-size": "22px",
                                  color: "#ffcb42",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticStyle: { flex: "1", padding: "0 5px" } }, [
                    _c("div", { staticClass: "warehousingCon" }, [
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3",
                          staticStyle: {
                            "font-size": "14px",
                            "margin-bottom": "5px",
                          },
                        },
                        [_vm._v("实际入库票数")]
                      ),
                      _c("div", { staticClass: "itemPu colorAdaeb3" }, [
                        _vm._v("Qtd. Real de Volumes para Entrada"),
                      ]),
                      _c("div", { staticClass: "itemQuantity" }, [
                        _vm._v(_vm._s(_vm.inboundData.actualWaybillCnt)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "itemIconCon",
                          staticStyle: { background: "#eef6ff" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "itemIcon",
                              staticStyle: { background: "#dbeafe" },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-ruku",
                                staticStyle: {
                                  "font-size": "22px",
                                  color: "#6387d4",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticStyle: { flex: "1", padding: "0 5px" } }, [
                    _c("div", { staticClass: "warehousingCon" }, [
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3",
                          staticStyle: {
                            "font-size": "14px",
                            "margin-bottom": "5px",
                          },
                        },
                        [_vm._v("入库差异")]
                      ),
                      _c("div", { staticClass: "itemPu colorAdaeb3" }, [
                        _vm._v("Divergência de Entrada"),
                      ]),
                      _c("div", { staticClass: "itemQuantity" }, [
                        _vm._v(_vm._s(_vm.inboundData.diffCnt)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "itemIconCon",
                          staticStyle: { background: "#fef2f2" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "itemIcon",
                              staticStyle: { background: "#ffe2e1" },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-a-zu143",
                                staticStyle: {
                                  "font-size": "20px",
                                  color: "#b46364",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("el-card", { staticClass: "box-card mb10" }, [
                _c(
                  "div",
                  { staticClass: "mb10 titleCon" },
                  [
                    _vm._v("退件数据监控 Monitoramento de dados de devolução "),
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "bottom-start", trigger: "hover" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              padding: "0",
                              "line-height": "16px",
                            },
                            attrs: {
                              slot: "reference",
                              type: "text",
                              size: "mini",
                            },
                            slot: "reference",
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-more",
                              staticStyle: {
                                "margin-left": "10px",
                                "font-size": "24px",
                                color: "#00A551",
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t("collectionCenter.detail"),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewDataTable(2)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-tiaozhuan",
                                      staticStyle: { "font-size": "20px" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t("GlobalSetObj.Download"),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadData(2)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-xiazai",
                                      staticStyle: { "font-size": "20px" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c("div", { staticStyle: { flex: "1", padding: "0 5px" } }, [
                    _c("div", { staticClass: "warehousingCon" }, [
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3",
                          staticStyle: {
                            "font-size": "14px",
                            "margin-bottom": "5px",
                          },
                        },
                        [_vm._v("应退件票数")]
                      ),
                      _c("div", { staticClass: "itemPu colorAdaeb3" }, [
                        _vm._v("Qtd. de Volumes para Devolução"),
                      ]),
                      _c("div", { staticClass: "itemQuantity" }, [
                        _vm._v(_vm._s(_vm.returnData.exceptReturnWaybillCnt)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "itemIconCon",
                          staticStyle: { background: "#fffbea" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "itemIcon",
                              staticStyle: { background: "#fdf2c3" },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-huituijian",
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#ffcb42",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticStyle: { flex: "1", padding: "0 5px" } }, [
                    _c("div", { staticClass: "warehousingCon" }, [
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3",
                          staticStyle: {
                            "font-size": "14px",
                            "margin-bottom": "5px",
                          },
                        },
                        [_vm._v("及时退件票数")]
                      ),
                      _c("div", { staticClass: "itemPu colorAdaeb3" }, [
                        _vm._v("Qtd. de Volumes para Devolução em Tempo Hábil"),
                      ]),
                      _c("div", { staticClass: "itemQuantity" }, [
                        _vm._v(_vm._s(_vm.returnData.onTimeReturnCnt)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "itemIconCon",
                          staticStyle: { background: "#eef6ff" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "itemIcon",
                              staticStyle: { background: "#dbeafe" },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-huituijian",
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#6387d4",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticStyle: { flex: "1", padding: "0 5px" } }, [
                    _c("div", { staticClass: "warehousingCon" }, [
                      _c(
                        "div",
                        {
                          staticClass: "colorAdaeb3",
                          staticStyle: {
                            "font-size": "14px",
                            "margin-bottom": "5px",
                          },
                        },
                        [_vm._v("及时退件率")]
                      ),
                      _c("div", { staticClass: "itemPu colorAdaeb3" }, [
                        _vm._v("Taxa de Devolução em Tempo Hábil"),
                      ]),
                      _c("div", { staticClass: "itemQuantity" }, [
                        _vm._v(_vm._s(_vm.returnData.onTimeReturnRate)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "itemIconCon",
                          staticStyle: { background: "#eafdf7" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "itemIcon",
                              staticStyle: { background: "#cefde6" },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "iconfont icon-weixietongji_zhuantitongji",
                                staticStyle: {
                                  "font-size": "22px",
                                  color: "#329a72",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { "padding-left": "5px" }, attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  { staticClass: "mb10 titleCon" },
                  [
                    _vm._v("滞留情况 Situação de Retenção "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { padding: "6px 0" },
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadData(5)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "iconfont icon-xiazai",
                          staticStyle: { "font-size": "20px" },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("detain-efficiency-chart", {
                      attrs: {
                        "chart-data": _vm.detainEfficiencyData,
                        total: _vm.detainTotal,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "mb10" },
        [
          _c(
            "el-col",
            { staticStyle: { "padding-right": "5px" }, attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  { staticClass: "mb10 titleCon" },
                  [
                    _vm._v("时效达成 Cumprimento do Prazo "),
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "bottom-start", trigger: "hover" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              padding: "0",
                              "line-height": "16px",
                            },
                            attrs: {
                              slot: "reference",
                              type: "text",
                              size: "mini",
                            },
                            slot: "reference",
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-more",
                              staticStyle: {
                                "margin-left": "10px",
                                "font-size": "24px",
                                color: "#00A551",
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t("collectionCenter.detail"),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewDataTable(3)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-tiaozhuan",
                                      staticStyle: { "font-size": "20px" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t("GlobalSetObj.Download"),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadData(3)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-xiazai",
                                      staticStyle: { "font-size": "20px" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("validity-efficiency-chart", {
                      attrs: {
                        "chart-data": _vm.validityEfficiencyData,
                        title: _vm.validityTitle,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { "padding-left": "5px" }, attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  { staticClass: "mb10 titleCon" },
                  [
                    _vm._v("虚假签收监控 Monitoramento de Recebimento Falso "),
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "bottom-start", trigger: "hover" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              padding: "0",
                              "line-height": "16px",
                            },
                            attrs: {
                              slot: "reference",
                              type: "text",
                              size: "mini",
                            },
                            slot: "reference",
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-more",
                              staticStyle: {
                                "margin-left": "10px",
                                "font-size": "24px",
                                color: "#00A551",
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t("collectionCenter.detail"),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewDataTable(4)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-tiaozhuan",
                                      staticStyle: { "font-size": "20px" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: _vm.$t("GlobalSetObj.Download"),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadData(4)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-xiazai",
                                      staticStyle: { "font-size": "20px" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("fake-efficiency-chart", {
                      attrs: {
                        "chart-data": _vm.falseDeliveryEfficiencyData,
                        title: _vm.falseDeliveryTitle,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { "padding-right": "5px" }, attrs: { span: 16 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    { staticClass: "mb10 titleCon" },
                    [
                      _vm._v("异常件监控 Monitoramento de Peças Anômalas "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { padding: "0" },
                          attrs: { size: "mini", type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadData(6)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "iconfont icon-xiazai",
                            staticStyle: { "font-size": "20px" },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.abnormalData, height: 335 } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "序号 Nº",
                          width: "80",
                          align: "center",
                          type: "index",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "异常件原因 Motivo das Peças Anômalas",
                          prop: "reason",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "异常件数量 Qtd. de Peças Anômalas",
                          prop: "problemNum",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "异常件占比% Percentual de Peças Anômalas",
                          prop: "problemRate",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      (row.problemRate * 100).toFixed(2) + "%"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { "padding-left": "5px" }, attrs: { span: 8 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", { staticClass: "mb10 titleCon" }, [
                  _vm._v("效率监控 Monitoramento de Eficiência"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "warehousingCon",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "colorAdaeb3",
                        staticStyle: {
                          "font-size": "14px",
                          "margin-bottom": "5px",
                          width: "220px",
                        },
                      },
                      [
                        _vm._v(
                          "首派及时率 Taxa de Pontualidade da Primeira Entrega"
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "itemQuantity" }, [
                      _vm._v(
                        _vm._s(
                          parseFloat(
                            _vm.efficiencyData.firstDeliveryOnTimeRate * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "itemIconCon",
                        staticStyle: { background: "#ecfdf7" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "itemIcon",
                            staticStyle: { background: "#cdfce4" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-peisongzhong",
                              staticStyle: {
                                "font-size": "22px",
                                color: "#24af80",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "warehousingCon",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "colorAdaeb3",
                        staticStyle: {
                          "font-size": "14px",
                          "margin-bottom": "5px",
                          width: "240px",
                        },
                      },
                      [
                        _vm._v(
                          "骑手上岗率 Taxa de Comparecimento dos Entregadores"
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "itemQuantity" }, [
                      _vm._v(
                        _vm._s(
                          parseFloat(
                            _vm.efficiencyData.riderWorkRate * 100
                          ).toFixed(2) + "%"
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "itemIconCon",
                        staticStyle: { background: "#ecfdf7" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "itemIcon",
                            staticStyle: { background: "#cdfce4" },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-a-zu228",
                              staticStyle: {
                                "font-size": "20px",
                                color: "#24af80",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "warehousingCon mb10" }, [
                  _c(
                    "div",
                    {
                      staticClass: "colorAdaeb3",
                      staticStyle: {
                        "font-size": "14px",
                        "margin-bottom": "5px",
                        width: "220px",
                      },
                    },
                    [_vm._v("派件效能 Eficiência de Entrega")]
                  ),
                  _c("div", { staticClass: "itemQuantity" }, [
                    _vm._v(_vm._s(_vm.efficiencyData.deliveryEfficiencyRate)),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "itemIconCon",
                      staticStyle: { background: "#ecfdf7" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "itemIcon",
                          staticStyle: { background: "#cdfce4" },
                        },
                        [
                          _c("i", {
                            staticClass: "iconfont icon-xiaoneng",
                            staticStyle: {
                              "font-size": "22px",
                              color: "#24af80",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.titleTable,
            visible: _vm.dialogVisibleDetail,
            width: "90%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleDetail = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "detailRef",
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    height: "500",
                    "header-cell-style": {
                      background: "#f2f2f2",
                      color: "black",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.serial"),
                      align: "center",
                      type: "index",
                      width: "80",
                    },
                  }),
                  _vm._l(_vm.columnTable, function (item, index) {
                    return _c("el-table-column", {
                      key: index,
                      attrs: {
                        label: item.label,
                        prop: item.prop,
                        align: "center",
                      },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadData(_vm.exportType)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.export")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleDetail = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }